export const CHANGE_PERIOD = 'CHANGE_PERIOD';

export const changePeriod = period => ({ type: CHANGE_PERIOD, payload: Number(period) });
